import React from 'react'
import { Spin } from 'antd'
import '../styles/Workspace.scss'
class Loading extends React.Component {
  render() {
    return (
      <div className='Workspace-delete'>
        <Spin tip='Loading...'></Spin>
      </div>
    )
  }
}
export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.js